export const COMPETITION_LEVEL_OPTIONS = [
    {value: "recreational", label: "Recreational"},
    {value: "competitive", label: "Competitive"},
    {value: "select", label: "Select"},
    {value: "elite", label: "Elite"},
];

export const AGE_GROUP_OPTIONS = [
    {value: "u8", label: "U8"},
    {value: "u10", label: "U10"},
    {value: "u12", label: "U12"},
    {value: "u14", label: "U14"},
    {value: "u16", label: "U16"},
    {value: "u18", label: "U18"},
    {value: "adult", label: "Adult"},
    {value: "senior", label: "Senior"},
];
